import { SDUIComponentInstanceRendererProps } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/__internal__/types";
import { ComponentLoggingEventParams } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/__internal__/types";
import { SDUISearchSuggestionPillRenderer } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/ComponentRenderers/SearchDropdown/SearchSuggestions/SDUISearchSuggestionsPillRenderer";
import { SDUITextRenderer } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/ComponentRenderers/Typography/SDUITextRenderer";
import { ResultsDropdownSectionsWrapper } from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/ResultDropdown/__internal__/Styled";
import { ISearchSuggestionPill } from "@faire/web-api--source/indigofair/data/ISearchSuggestionPill";
import { Row } from "@faire/web/slate/Layout";
import { useResponsiveValue } from "@faire/web/ui/hooks/useResponsiveValue";
import { useCallback, useState } from "react";

const DEFAULT_MAXIMUM_PILL_COUNT = 10;

export const SDUISearchSuggestionsRenderer: React.FC<
  SDUIComponentInstanceRendererProps
> = ({ component, loggingData }) => {
  const { search_suggestions_component } = component;
  const [pillCount, setPillCount] = useState(
    search_suggestions_component?.pills?.length ?? 0
  );
  const { responsive_pills_config } = search_suggestions_component ?? {};

  const maximumPillCount =
    useResponsiveValue({
      xLargeAndAbove: responsive_pills_config?.x_large_and_above,
      desktopAndAbove: responsive_pills_config?.desktop_and_above,
      tabletAndAbove: responsive_pills_config?.tablet_and_above,
      mobileAndAbove: responsive_pills_config?.mobile_and_above,
    }) ?? DEFAULT_MAXIMUM_PILL_COUNT;

  const onPillDismiss = useCallback(() => {
    setPillCount((pillCount) => pillCount - 1);
  }, []);

  if (!search_suggestions_component || pillCount < 1) {
    return null;
  }

  const { title, pills } = search_suggestions_component;

  return (
    <ResultsDropdownSectionsWrapper data-test-id="SDUI-search-suggestions-renderer">
      <div className="mx-1.5">
        <SDUITextRenderer text={title} />
      </div>
      <SDUISearchSuggestionsSection
        pills={pills}
        loggingData={loggingData}
        onPillDismiss={onPillDismiss}
        maximumPillCount={maximumPillCount}
      />
    </ResultsDropdownSectionsWrapper>
  );
};

const SDUISearchSuggestionsSection = ({
  pills,
  loggingData,
  onPillDismiss,
  maximumPillCount,
}: {
  pills: ISearchSuggestionPill[] | undefined;
  loggingData: ComponentLoggingEventParams;
  onPillDismiss: () => void;
  maximumPillCount: number;
}) => {
  if (!pills) {
    return null;
  }

  return (
    <Row
      className="flex flex-wrap py-0.5 pt-2"
      align="center"
      data-test-id="SDUI-search-suggestions-section"
    >
      {pills.slice(0, maximumPillCount).map((pill, i) => {
        return (
          <SDUISearchSuggestionPillRenderer
            key={`SDUISuggestionPill-${pill.variant}-${i}`}
            pill={pill}
            onPillDismiss={onPillDismiss}
            loggingData={loggingData}
          />
        );
      })}
    </Row>
  );
};
